import { Button } from "../Button";

import * as theme from "./AIRetry.css";

interface AIRetryProps {
    message: string;
    retryLabel: string;
    onRetry: () => void;
    variant?: "centered" | "fullWidth";
}

export function AIRetry({
    message,
    retryLabel,
    onRetry,
    variant = "centered",
}: AIRetryProps) {
    return (
        <div className={theme.errorState[variant]}>
            <span>{message}</span>
            <Button
                variant="text"
                size="nosize"
                className={theme.retryButton}
                onClick={onRetry}
            >
                {retryLabel}
            </Button>
        </div>
    );
}
